module.exports = __webpack_public_path__ + "img/punda-detail.03e08823.jpg";